import AdminWrapper from '../../pages/backoffice/admin/_index.jsx';
import {
  ShopsCreate,
  ShopsEdit,
  ShopsImport,
  ShopsList,
  ShopsShow,
} from '../../pages/backoffice/admin/shops/_index.js';
import {
  StaffCreate,
  StaffEdit,
  StaffList,
  StaffShow,
} from '../../pages/backoffice/admin/staff/_index.js';
import {
  EligibilityWatchlistCreate,
  EligibilityWatchlistEdit,
  EligibilityWatchlistImport,
  EligibilityWatchlistList,
  EligibilityWatchlistShow,
} from '../../pages/backoffice/admin/eligibility-watchlist/_index.js';

export const backofficeRoutesAdmin = {
  path: 'admin',
  element: <AdminWrapper />,
  children: [
    {
      path: 'staff',
      children: [
        { index: true, element: <StaffList /> },
        { path: 'create', element: <StaffCreate /> },
        { path: ':staffId', element: <StaffShow /> },
        { path: ':staffId/edit', element: <StaffEdit /> },
      ],
    },
    {
      path: 'shops',
      children: [
        { index: true, element: <ShopsList /> },
        { path: 'create', element: <ShopsCreate /> },
        { path: ':shopId', element: <ShopsShow /> },
        { path: ':shopId/edit', element: <ShopsEdit /> },
        { path: 'import', element: <ShopsImport /> },
      ],
    },
    {
      path: 'eligibility-watchlist',
      children: [
        { index: true, element: <EligibilityWatchlistList /> },
        { path: 'create', element: <EligibilityWatchlistCreate /> },
        { path: ':eligibilityWatchlistId', element: <EligibilityWatchlistShow /> },
        { path: ':eligibilityWatchlistId/edit', element: <EligibilityWatchlistEdit /> },
        { path: 'import', element: <EligibilityWatchlistImport /> },
      ],
    },
  ],
};
